export default {"src":"/_next/static/media/2.e7cfb211.svg","height":170,"width":305,"blurWidth":0,"blurHeight":0};